
/* TJ B2C Gift Box, v2. Product page: reserve for Add to Cart. Cart: add immediately. */
(function(){
'use strict';
if(window.TJGiftBoxV2) return;
window.TJGiftBoxV2=true;
var CART_ROOT=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
function find(node,selector){return node.querySelector(selector)}
function all(node,selector){return Array.prototype.slice.call(node.querySelectorAll(selector))}
function toast(message){
 var t=document.createElement('div');t.className='tjgb-toast';t.setAttribute('role','status');t.textContent=message;document.body.appendChild(t);
 window.setTimeout(function(){t.remove()},4500);
}
function classify(item){
 var title=String(item.product_title||item.title||'').trim().toLowerCase();
 var prefix=String(item.product_title||item.title||'').trim().slice(0,4).toUpperCase();
 var sku=String(item.sku||'').slice(0,4).toUpperCase();
 var type=String(item.product_type||'').toLowerCase();
 if(prefix==='JSPH'||sku==='JSPH'||title.includes('gift box')||title.includes('handbag')||title.includes('hand bag')||type.includes('bag'))return [];
 if(prefix==='TNCH')return ['bracelet','pendant'];
 if(prefix==='BRHH'||sku==='BRHH'||/broach|brooch/.test(title)||/broach|brooch/.test(type))return ['pendant'];
 if(prefix==='MTHH'||sku==='MTHH'||prefix==='NTHH'||sku==='NTHH'||prefix.startsWith('PYH')||sku.startsWith('PYH')||prefix.startsWith('CHH')||sku.startsWith('CHH')||/earcuff|ear cuff|anklet|payal|nose ring|nose pin|nosepin|nath|matha|\bchain\b/.test(title))return ['ring','pendant'];
 if(title.includes('necklace')||title.includes('mala'))return [];
 if(['TEDH','CEDH','TEHH','CEHH','TETH','CETH','TESH','CESH','TEPH','CEPH'].includes(prefix)||['TEDH','CEDH','TEHH','CEHH','TETH','CETH','TESH','CESH','TEPH','CEPH'].includes(sku)||/earring|ear studs|ear tops/.test(title))return ['ring','pendant'];
 if(['TRGH','TRSH','CRGH','CRSH'].includes(prefix)||['TRGH','TRSH','CRGH','CRSH'].includes(sku)||type==='rings'||/ ring|rings /.test(title))return ['ring'];
 if(['TBCH','CBCH','TBRH','CBRH'].includes(prefix)||['TBCH','CBCH','TBRH','CBRH'].includes(sku)||title.includes('bracelet'))return ['bracelet'];
 if(['TPSH','CPSH'].includes(prefix)||['TPSH','CPSH'].includes(sku)||/pendant|pendent/.test(title))return ['pendant'];
 if(['WHL','WHM','WMH','MWL'].includes(prefix.slice(0,3))||['WHL','WHM','WMH','MWL'].includes(sku.slice(0,3))||title.includes('watch'))return ['watch','premium'];
 return [];
}
function apiCart(){
 return fetch(CART_ROOT+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw Error('Cart could not be loaded');return r.json()});
}
function updateThemeCart(){
 return new Promise(function(resolve){
  if(window.CartJS&&typeof CartJS.getCart==='function'){
   try{var v=CartJS.getCart();if(v&&typeof v.always==='function'){v.always(resolve);return}if(v&&typeof v.then==='function'){v.then(resolve,resolve);return}}catch(e){}
  }resolve();
 });
}
function start(root){
 if(root.dataset.tjgbReady)return;
 root.dataset.tjgbReady='1';
 var scope=root.dataset.tjgbScope,form=scope==='product'?root.closest('form'):null;
 var layer=find(root,'[data-tjgb-layer]'),lightbox=find(root,'[data-tjgb-lightbox]');
 var dialog=find(layer,'.tjgb-dialog'),apply=find(layer,'[data-tjgb-apply]');
 var opener=find(root,'[data-tjgb-open]'),status=find(root,'[data-tjgb-state]');
 var error=find(root,'[data-tjgb-error]'),summary=find(root,'[data-tjgb-summary]');
 var remove=find(root,'[data-tjgb-remove]');
 var originalSummary=summary?summary.textContent:'',originalButton=opener.textContent;
 var chosen=null,cartData=null,busy=false,lastFocus=null,disabled=false,cartCheckSeq=0,refreshTimer=null;
 // Put modal at document body level; drawer can use a CSS transform stacking context.
 document.body.appendChild(layer);document.body.appendChild(lightbox);
 function warn(s){error.hidden=!s;error.textContent=s||''}
 function info(s){if(!status)return;status.hidden=!s;status.textContent=s||''}
 function options(){return all(layer,'[data-giftbox]')}
 function activeChoice(){return find(layer,'[data-giftbox-radio]:checked')}
 function picked(){
  var radio=activeChoice();if(!radio)return null;
  var item=radio.closest('[data-giftbox]');
  var v=find(item,'[data-giftbox-variant].is-active');
  return {id:v?v.dataset.variantId:radio.value,price:v?v.dataset.price:find(item,'[data-giftbox-price]').textContent.trim(),color:v?v.dataset.color:'',name:item.dataset.label,kind:item.dataset.key};
 }
 function updateChoice(){
  options().forEach(function(o){o.classList.toggle('is-current',!!find(o,'[data-giftbox-radio]:checked'))});
  apply.disabled=!picked()||busy;
 }
 function selectOption(o){
  options().forEach(function(other){var radio=find(other,'[data-giftbox-radio]');radio.checked=other===o});
  updateChoice();
 }
 function selectVariant(button){
  var o=button.closest('[data-giftbox]');
  all(o,'[data-giftbox-variant]').forEach(function(b){var on=b===button;b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',on?'true':'false')});
  find(o,'[data-giftbox-radio]').value=button.dataset.variantId;
  find(o,'[data-giftbox-price]').textContent=button.dataset.price;
  if(button.dataset.variantImage){var main=find(o,'[data-tjgb-view-photo]');if(main){main.dataset.img=button.dataset.variantFull;var img=find(main,'img');if(img)img.src=button.dataset.variantImage;}}
  selectOption(o);
 }
 async function open(){
  warn('');lastFocus=document.activeElement;
  if(scope==='cart'){await refreshCart();if(root.hidden)return;}
  layer.hidden=false;
  if(scope==='product'){
   if(chosen){
    var match=options().find(function(o){return !!find(o,'[data-giftbox-variant][data-variant-id="'+chosen.id+'"]')||find(o,'[data-giftbox-radio]').value===chosen.id});
    if(match){var b=find(match,'[data-giftbox-variant][data-variant-id="'+chosen.id+'"]');if(b)selectVariant(b);else selectOption(match)}
   }else options().forEach(function(o){find(o,'[data-giftbox-radio]').checked=false});
  }
  updateChoice();dialog.focus();
 }
 function close(){layer.hidden=true;if(lastFocus&&lastFocus.focus)lastFocus.focus()}
 function closeLightbox(){lightbox.hidden=true}
 all(layer,'[data-tjgb-close]').forEach(function(n){n.addEventListener('click',close)});
 find(layer,'[data-tjgb-skip]').addEventListener('click',function(){if(scope==='product'&&chosen){clearProduct()}close()});
 opener.addEventListener('click',open);
 all(layer,'[data-giftbox-radio]').forEach(function(r){r.addEventListener('change',function(){selectOption(r.closest('[data-giftbox]'))})});
 layer.addEventListener('click',function(e){
  // Keep the original Avone drawer open while interacting with this body-level modal.
  e.stopPropagation();
  var variant=e.target.closest('[data-giftbox-variant]');
  if(variant){e.preventDefault();selectVariant(variant);return}
  var thumbnail=e.target.closest('[data-tjgb-thumbnail]');
  if(thumbnail){
   var o=thumbnail.closest('[data-giftbox]'),main=find(o,'[data-tjgb-view-photo]');
   all(o,'[data-tjgb-thumbnail]').forEach(function(t){t.classList.toggle('is-current',t===thumbnail)});
   if(main){main.dataset.img=thumbnail.dataset.fullImage;var img=find(main,'img');if(img)img.src=thumbnail.dataset.thumbImage}
   openLightbox(thumbnail.dataset.fullImage);return;
  }
  var big=e.target.closest('[data-tjgb-view-photo]');
  if(big){openLightbox(big.dataset.img);return}
 });
 function openLightbox(src){if(!src)return;find(lightbox,'[data-tjgb-lightbox-image]').src=src;lightbox.hidden=false}
 find(lightbox,'[data-tjgb-lightbox-close]').addEventListener('click',closeLightbox);
 lightbox.addEventListener('click',function(e){e.stopPropagation();if(e.target===lightbox)closeLightbox()});
 document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;if(!lightbox.hidden)closeLightbox();else if(!layer.hidden)close()});
 function clearProduct(){chosen=null;if(summary)summary.textContent=originalSummary;opener.textContent=originalButton;if(remove)remove.hidden=true;if(form)form.classList.remove('tjgb-with-box');info('');warn('')}
 if(remove)remove.addEventListener('click',clearProduct);
 // Cart upsells depend only on current items; never ask for an item association.
 function allowedFromCart(cart){
  var allowed=new Set(),inCart=new Set();
  (cart.items||[]).forEach(function(item){
   if(String(item.sku||'').toUpperCase().startsWith('JSPH')||/^JSPH/i.test(String(item.product_title||''))){
    inCart.add(Number(item.variant_id));return;
   }
   classify(item).forEach(function(k){allowed.add(k)});
  });
  return {allowed:allowed,inCart:inCart};
 }
 async function refreshCart(){
  if(scope!=='cart'||disabled)return;
  var seq=++cartCheckSeq;
  try{
   var updated=await apiCart();
   if(seq!==cartCheckSeq)return;
   cartData=updated;
   var state=allowedFromCart(updated);
   options().forEach(function(o){
    var variants=all(o,'[data-giftbox-variant]');
    var firstId=Number(find(o,'[data-giftbox-radio]').value);
    var already=state.inCart.has(firstId)||variants.some(function(v){return state.inCart.has(Number(v.dataset.variantId))});
    var eligible=state.allowed.has(o.dataset.key)&&!already;
    o.hidden=!eligible;
    if(!eligible)find(o,'[data-giftbox-radio]').checked=false;
   });
   var any=options().some(function(o){return !o.hidden});
   root.hidden=!any;
   if(!any&&!layer.hidden)close();
   updateChoice();
  }catch(e){
   if(seq!==cartCheckSeq)return;
   root.hidden=true;
   if(!layer.hidden)close();
  }
 }
 function scheduleCartRefresh(delay){
  if(scope!=='cart')return;
  window.clearTimeout(refreshTimer);
  refreshTimer=window.setTimeout(function(){refreshCart()},delay==null?150:delay);
 }
 apply.addEventListener('click',async function(){
  var candidate=picked();if(!candidate||busy)return;
  if(scope==='product'){
   chosen=candidate;
   var label=candidate.name.replace(/^JSPH\d+\s+AMB\s+/i,'').replace(/\s*-\s*JSPH$/i,'');
   if(summary)summary.textContent=label+(candidate.color?' · '+candidate.color:'')+' · '+candidate.price;
   opener.textContent='Change Gift Box ›';remove.hidden=false;form.classList.add('tjgb-with-box');
   info('Selected — your gift box will be added when you press Add to Cart.');
   close();return;
  }
  busy=true;apply.disabled=true;warn('');info('');
  try{
   // Make an independent fresh cart check at the final click (no stale/racing UI reads).
   var latest=allowedFromCart(await apiCart());
   var selectedBox=options().find(function(o){return o.dataset.key===candidate.kind});
   var alreadyPresent=selectedBox&&all(selectedBox,'[data-giftbox-variant]').some(function(v){return latest.inCart.has(Number(v.dataset.variantId))});
   if(selectedBox&&latest.inCart.has(Number(find(selectedBox,'[data-giftbox-radio]').value)))alreadyPresent=true;
   if(!selectedBox||!latest.allowed.has(candidate.kind)||alreadyPresent){
    await refreshCart();
    throw Error('This gift box is no longer suitable for the current cart.');
   }
   var resp=await fetch(CART_ROOT+'cart/add.js',{method:'POST',credentials:'same-origin',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({items:[{id:Number(candidate.id),quantity:1,properties:{'_TJ Gift Box Add-On':'Yes'}}]})});
   var body=await resp.json();
   if(!resp.ok)throw Error(body.description||body.message||'Please try again');
   close();toast('Gift box added to your cart.');
   if(root.dataset.tjgbLocation==='page'){window.location.reload();return}
   await updateThemeCart();await refreshCart();
   var drawer=document.getElementById('cart-drawer');if(drawer)drawer.classList.add('active');
  }catch(e){warn('Could not add gift box: '+(e.message||'Please try again'))}
  finally{busy=false;updateChoice()}
 });
 if(scope==='product'){
  async function addTogether(){
   if(!chosen||busy)return;
   var data=new FormData(form),variant=data.get('id');
   var qty=Math.max(1,Math.min(99,parseInt(data.get('quantity')||'1',10)||1));
   if(!variant){warn('Please select a product variant.');return}
   var main={id:Number(variant),quantity:qty,properties:{'Gift Box':chosen.name+(chosen.color?' ('+chosen.color+')':'')}};
   var props={};data.forEach(function(value,key){var m=/^properties\[(.+)\]$/.exec(key);if(m&&value)props[m[1]]=String(value)});
   Object.assign(main.properties,props);
   if(data.get('selling_plan'))main.selling_plan=Number(data.get('selling_plan'));
   var box={id:Number(chosen.id),quantity:qty,properties:{'_TJ Gift Box For':root.dataset.productTitle,'_TJ Gift Box Add-On':'Yes'}};
   busy=true;warn('');
   var btn=find(form,'.product-form__cart-submit');
   if(btn)btn.disabled=true;
   try{
    var resp=await fetch(CART_ROOT+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[main,box]})});
    var body=await resp.json();if(!resp.ok)throw Error(body.description||body.message||'Please try again');
    await updateThemeCart();toast('Product and gift box added to cart.');
    clearProduct();
    var drawer=document.getElementById('cart-drawer');if(drawer)drawer.classList.add('active');
   }catch(e){warn('Could not add product and gift box: '+(e.message||'Please try again'))}
   finally{busy=false;if(btn)btn.disabled=false}
  }
  // Stop Avone's delegated click/touchend AJAX logic only if a box was selected.
  form.addEventListener('touchend',function(e){if(chosen&&e.target.closest('.product-form__cart-submit'))e.stopPropagation()},true);
  form.addEventListener('click',function(e){if(chosen&&e.target.closest('.product-form__cart-submit')){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();addTogether()}},true);
  form.addEventListener('submit',function(e){if(chosen){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();addTogether()}},true);
 }else{
  refreshCart();
  // A CartJS update or a drawer opening can change eligibility.
  if(window.jQuery){
   window.jQuery(document).on('cart.requestComplete',function(){scheduleCartRefresh(180)});
   window.jQuery(document).on('click','.header-cart',function(){scheduleCartRefresh(200)});
   window.jQuery(document).on('click','.mini-products-list .remove, .mini-products-list .qtyBtn, .cart__row .remove, .cart__row .qtyBtn, .removeMb',function(){scheduleCartRefresh(650)});
   window.jQuery(document).ajaxComplete(function(_e,_xhr,settings){
    if(settings&&/\/cart\/(?:change|update|clear|add)(?:\.js)?(?:\?|$)/.test(settings.url||''))scheduleCartRefresh(250);
   });
  }
  if(root.dataset.tjgbLocation==='drawer'){
   var drawer=document.getElementById('cart-drawer');
   if(drawer&&window.MutationObserver){
    new MutationObserver(function(){if(drawer.classList.contains('active'))scheduleCartRefresh(130)}).observe(drawer,{attributes:true,attributeFilter:['class']});
    var lines=drawer.querySelector('.mini-products-list');
    if(lines)new MutationObserver(function(){scheduleCartRefresh(130)}).observe(lines,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['data-cart-remove','rv-each-item']});
   }
  }
 }
}
function mount(){
 var products=all(document,'[data-tjgb-scope="product"]');
 if(products.length>1){
  var keep=products.find(function(p){return !!p.offsetParent})||products[0];
  products.forEach(function(p){if(p!==keep)p.remove()});
 }
 all(document,'[data-tjgb]').forEach(start);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
document.addEventListener('shopify:section:load',mount);
})();
